import { useReportClock } from '../reportClock';

import React, { useEffect, useState } from 'react';
import { AlertTriangle, FileText } from 'react-feather';
import { H5, P } from '../../../AbstractElements';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { Link } from 'react-router-dom';
import {
    loadVehicleNoticeAlerts,
    VEHICLE_NOTICE_ALERT_THRESHOLD,
} from '../VehicleAlerts/vehicleAlertsData';
import AvisDetailModal, { AvisDetailModalTrigger } from '../Avis/AvisDetailModal';

const MAX_DASHBOARD_ALERTS = 5;

const LatestActivityClass = () => {
  const reportNow = useReportClock();
    const [alerts, setAlerts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [selectedAvisId, setSelectedAvisId] = useState('');

    useEffect(() => {
        let active = true;

        const loadAlerts = async () => {

            setError('');

            try {
                const result = await loadVehicleNoticeAlerts({ includeLegacyTickets: false });

                if (active) {
                    setAlerts(result.alerts.slice(0, MAX_DASHBOARD_ALERTS));
                }
            } catch (loadError) {
                if (active) {
                    setAlerts([]);
                    setError(loadError.message || 'Impossible de charger les alertes vehicules.');
                }
            } finally {
                if (active) {
                    setLoading(false);
                }
            }
        };

        loadAlerts();

        return () => {
            active = false;
        };
    }, [reportNow]);

    const renderAlertsTable = () => (
        <div className="table-responsive">
            <table className="table table-bordernone m-0">
                <tbody>
                    {alerts.map(alert => (
                        <tr key={alert.id}>
                            <td>
                                <div className="media">
                                    <AlertTriangle className={alert.level === 'critical' ? 'font-danger' : 'font-primary'} />
                                    <div className="media-body">
                                        <Link to={`${process.env.PUBLIC_URL}/dashboard/alertes-vehicules?plate=${encodeURIComponent(alert.plateNormalized)}`}>
                                            <span>{alert.plate}</span>
                                        </Link>
                                        <P>
                                            {alert.noticeCount} avis
                                            {alert.vehicleDescription ? ` - ${alert.vehicleDescription}` : ''}
                                        </P>
                                    </div>
                                </div>
                            </td>
                            <td>
                                {alert.latestTicketId ? (
                                    <div className="d-inline-flex align-items-center">
                                        <Link to={`${process.env.PUBLIC_URL}/dashboard/avis/${encodeURIComponent(alert.latestTicketId)}`}>
                                            #{alert.latestTicketId}
                                        </Link>
                                        <AvisDetailModalTrigger avisId={alert.latestTicketId} onOpen={setSelectedAvisId} />
                                    </div>
                                ) : '-'}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    return (
        <>
        <Card className="latest-update-sec">
            <CardHeader>
                <div className="header-top d-sm-flex align-items-center">
                    <H5 attrH5={{ style: { textTransform: 'none' } }}>Vehicules a surveiller</H5>
                    <div className="center-content">
                        <Link className="font-primary" to={`${process.env.PUBLIC_URL}/dashboard/alertes-vehicules`}>
                            Voir tout
                        </Link>
                    </div>
                </div>
            </CardHeader>
            <CardBody>
                {loading && (
                    <div className="text-center p-t-30 p-b-30">
                        <P>Chargement des alertes vehicules...</P>
                    </div>
                )}

                {!loading && error && (
                    <div className="alert alert-danger mb-0" role="alert">
                        {error}
                    </div>
                )}

                {!loading && !error && alerts.length === 0 && (
                    <div className="text-center p-t-30 p-b-30">
                        <FileText className="m-b-10" />
                        <P>Aucun vehicule a {VEHICLE_NOTICE_ALERT_THRESHOLD} avis ou plus.</P>
                    </div>
                )}

                {!loading && !error && alerts.length > 0 && (
                    renderAlertsTable()
                )}
            </CardBody>
        </Card>
        <AvisDetailModal
            avisId={selectedAvisId}
            isOpen={Boolean(selectedAvisId)}
            toggle={() => setSelectedAvisId('')}
        />
        </>
    );
};

export default LatestActivityClass;
